<template>
  <base-icon-button-picture-as-pdf :disabled="isDisabledPdfButton"
                                   :title="customPdfTitle"
                                   @click="onClick"/>
</template>

<script>
  import BaseIconButtonPictureAsPdf from '@/components/base-components/base-icons/BaseIconButtonPictureAsPdf';
  import { sendPdfToUser } from '@/helpers/pdfDownloadFunctions';

  export default {
    name: 'ActionDownloadPdf',
    components: { BaseIconButtonPictureAsPdf },
    props: {
      proposal: {
        type: Object,
        default: () => ({}),
      },
      customPdfLocation: {
        type: String,
        default: 'pdf_id',
      },
      customPdfTitle: {
        type: String,
        default: 'Proposal PDF',
      },
    },
    computed: {
      onClick() {
        return this.$listeners.click || this.handlePdf;
      },
      isDisabledPdfButton() {
        if (this.customPdfLocation === 'pdf_id') {
          return this.proposalDisabledAttributeValue ?? !this.hasProposalPdfIdProperty;
        }
        return false;
      },
      proposalDisabledAttributeValue() {
        return this.$attrs.disabled;
      },
      hasProposalPdfIdProperty() {
        return this.hasProperty(this.proposal, 'pdf_id');
      },
      pdfPath() {
        if (this.customPdfLocation !== 'pdf_id') {
          return `/documents/download/${this.customPdfLocation}`;
        }
        if (this.hasProposalPdfIdProperty) {
          return `/documents/download/${this.proposal.pdf_id}`;
        }
        return null;
      },
    },
    methods: {
      handlePdf() {
        if (this.customPdfLocation === 'pdf_id' && !this.proposal.pdf_id) {
          this.generatePdf(this.getId(this.proposal));
        } else {
          this.downloadPdf();
        }
      },
      async downloadPdf() {
        if (this.pdfPath) {
          const response = await this.axios.get(this.pdfPath);
          const { error } = response.data;
          if (error) {
            this.$notify({ type: 'error', title: 'PDF for this proposal doesn\'t exists' });
          } else if (this.hasProperty(response.data, 'msg')) {
            this.$notify({ type: 'error', title: response.data.msg });
          } else {
            sendPdfToUser(response.request.responseURL);
          }
        }
      },
    },
  };
</script>

<style scoped>

</style>
